import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../../../../app/components/Button";
import { FiSettings, FiSliders } from "react-icons/fi";
import { GrRobot } from "react-icons/gr";
import { Tabs } from "../../../../../../app/components/Tabs";
import EmailSequenceEdit from "../../../../../../forms/EmailSequences/EmailSequencesEdit";
import Toast from "../../../../../../app/components/Toast";

import TemplateEmail from "./EmailsTabs/TemplateEmail";
import EmailBox from "./EmailsTabs/EmailBox";

const EmailsSequences = () => {
  const [activeTab, setActiveTab] = useState("Caixa de Emails");
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const navigate = useNavigate();
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [toast, setToast] = useState({ show: false, type: "success", message: "" });

  const [dataTemplates, setDataTemplates] = useState([
    {
      id: 1,
      nome: "Alteração iniciada",
      assunto: "Bem-vindo à nossa plataforma!",
      sequencia: "Vendas e negociações",
      status: "ativo",
      criadoEm: "07/07/2025 08:40",
      destinatario: "email",
      corpoEmail: "<p>Olá {{Nome do cliente}}, seja bem-vindo!</p>",
    },
    {
      id: 2,
      nome: "Cliente não convertido",
      assunto: "Confirme seu cadastro",
      sequencia: "Vendas e negociações",
      status: "inativo",
      criadoEm: "05/07/2025 15:22",
      destinatario: "indicadoPor",
      corpoEmail: "<p>Prezado {{Nome do cliente}}, finalize seu cadastro.</p>",
    },
  ]);

  const showToast = (type, message) => {
    setToast({ show: true, type, message });
  };

  const handleSaveTemplate = (templateSalvo) => {
    setDataTemplates((prevTemplates) => {
      if (templateSalvo.id) {
        showToast("success", "Template atualizado com sucesso!");
        return prevTemplates.map((tpl) =>
          tpl.id === templateSalvo.id ? { ...tpl, ...templateSalvo } : tpl
        );
      }

      const novoId =
        prevTemplates.length > 0
          ? Math.max(...prevTemplates.map((t) => t.id)) + 1
          : 1;

      const novoTemplate = {
        ...templateSalvo,
        id: novoId,
        criadoEm: new Date().toLocaleString("pt-BR"),
      };

      showToast("success", "Template criado com sucesso!");

      return [...prevTemplates, novoTemplate];
    });

    setIsTemplateModalOpen(false);
  };

  return (
    <div>
      <div className="flex justify-between mb-14">
        <Button
          onClick={() => {
            setSelectedTemplate(null);
            setIsTemplateModalOpen(true);
          }}
        >
          <span>Criar template</span>
        </Button>
        <div className="flex gap-1">
          <Button onClick={() => navigate("/lista-automacoes")} variant="secondary" className="!p-2">
            <GrRobot size={18}/>
            <span>Automações</span>
          </Button>
          <Button onClick={() => navigate("/emails")} variant="secondary" className="!p-2">
            <FiSliders size={18}/>
            <span>Gestão de emails</span>
          </Button>
        </div>
      </div>

      <div className="mb-6">
        <Tabs
          tabs={[{ name: "Caixa de Emails" }, { name: "Templates" }]}
          activeTabName={activeTab}
          onTabClick={setActiveTab}
          align="left"
        />
      </div>

      {activeTab === "Caixa de Emails" ? (
        <EmailBox />
      ) : (
        <TemplateEmail
          dataTemplates={dataTemplates}
          setSelectedTemplate={setSelectedTemplate}
          setIsTemplateModalOpen={setIsTemplateModalOpen}
        />
      )}

      <EmailSequenceEdit
        isOpen={isTemplateModalOpen}
        onClose={() => setIsTemplateModalOpen(false)}
        templateData={selectedTemplate}
        onSave={handleSaveTemplate}
      />

      {toast.show && (
        <Toast
          type={toast.type}
          message={toast.message}
          duration={3000}
          onClose={() => setToast({ ...toast, show: false })}
        />
      )}
    </div>
  );
};

export default EmailsSequences;
